/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalNotesResponseDto
 */
export interface AdditionalNotesResponseDto {
    /**
     * Identity of the Additional Notes
     * @type {string}
     * @memberof AdditionalNotesResponseDto
     */
    id: string;
    /**
     * Patient identity
     * @type {string}
     * @memberof AdditionalNotesResponseDto
     */
    patientId: string;
    /**
     * Is there anything else important for us to know?
     * @type {string}
     * @memberof AdditionalNotesResponseDto
     */
    additionalImportantInformation?: string;
    /**
     * Are you comfortable with injectables?
     * @type {boolean}
     * @memberof AdditionalNotesResponseDto
     */
    comfortableWithInjectables: boolean;
    /**
     * Expected monthly budget
     * @type {string}
     * @memberof AdditionalNotesResponseDto
     */
    expectedMonthlyBudget: string;
    /**
     * Therapies tried previously
     * @type {string}
     * @memberof AdditionalNotesResponseDto
     */
    therapiesTriedPreviously?: string;
    /**
     * Last updated timestamp
     * @type {string}
     * @memberof AdditionalNotesResponseDto
     */
    lastUpdated: string;
}

/**
 * Check if a given object implements the AdditionalNotesResponseDto interface.
 */
export function instanceOfAdditionalNotesResponseDto(value: object): value is AdditionalNotesResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('comfortableWithInjectables' in value) || value['comfortableWithInjectables'] === undefined) return false;
    if (!('expectedMonthlyBudget' in value) || value['expectedMonthlyBudget'] === undefined) return false;
    if (!('lastUpdated' in value) || value['lastUpdated'] === undefined) return false;
    return true;
}

export function AdditionalNotesResponseDtoFromJSON(json: any): AdditionalNotesResponseDto {
    return AdditionalNotesResponseDtoFromJSONTyped(json, false);
}

export function AdditionalNotesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalNotesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'additionalImportantInformation': json['additionalImportantInformation'] == null ? undefined : json['additionalImportantInformation'],
        'comfortableWithInjectables': json['comfortableWithInjectables'],
        'expectedMonthlyBudget': json['expectedMonthlyBudget'],
        'therapiesTriedPreviously': json['therapiesTriedPreviously'] == null ? undefined : json['therapiesTriedPreviously'],
        'lastUpdated': json['lastUpdated'],
    };
}

export function AdditionalNotesResponseDtoToJSON(json: any): AdditionalNotesResponseDto {
    return AdditionalNotesResponseDtoToJSONTyped(json, false);
}

export function AdditionalNotesResponseDtoToJSONTyped(value?: AdditionalNotesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'additionalImportantInformation': value['additionalImportantInformation'],
        'comfortableWithInjectables': value['comfortableWithInjectables'],
        'expectedMonthlyBudget': value['expectedMonthlyBudget'],
        'therapiesTriedPreviously': value['therapiesTriedPreviously'],
        'lastUpdated': value['lastUpdated'],
    };
}

